import { render, staticRenderFns } from "./QuestionMultiText.vue?vue&type=template&id=c4a6bc62"
import script from "./QuestionMultiText.vue?vue&type=script&lang=js"
export * from "./QuestionMultiText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports